// Merken-Liste ohne App.
//
// Der Shop hat keine Wunschliste, und eine App nur fuer ein Herz waere zu
// viel. Gespeichert wird im localStorage des Besuchers.
//
// ponytail: Die Liste haengt am Browser, nicht am Kundenkonto. Wer den
// Rechner wechselt, sieht seine Merkliste nicht. Aufruesten liesse sich das
// spaeter ueber ein Customer-Metafeld, sobald es Kundenkonten gibt.
(function () {
  if (window.__gsMerken) return;
  window.__gsMerken = true;

  var KEY = 'gs:merken';

  // localStorage wirft im privaten Modus mancher Browser. Ein fehlgeschlagenes
  // Merken darf die Seite nicht mitreissen.
  function lies() {
    try {
      var roh = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(roh) ? roh : [];
    } catch (e) {
      return [];
    }
  }

  function schreib(liste) {
    try {
      localStorage.setItem(KEY, JSON.stringify(liste));
    } catch (e) {
      /* voll oder gesperrt: dann eben nur fuer diese Seite */
    }
  }

  function zeichne() {
    var liste = lies();
    var knoepfe = document.querySelectorAll('[data-merken]');
    for (var i = 0; i < knoepfe.length; i++) {
      var b = knoepfe[i];
      var an = liste.indexOf(b.getAttribute('data-merken')) > -1;
      b.setAttribute('aria-pressed', an ? 'true' : 'false');
    }
    // Zahl neben dem Herz im Kopf. Sie erscheint nur, wenn wirklich etwas
    // gemerkt ist, sonst klebte ein leerer Punkt am Symbol.
    var zahlen = document.querySelectorAll('[data-merken-zahl]');
    for (var j = 0; j < zahlen.length; j++) {
      zahlen[j].textContent = liste.length ? String(liste.length) : '';
      if (liste.length) {
        zahlen[j].removeAttribute('hidden');
      } else {
        zahlen[j].setAttribute('hidden', '');
      }
    }
  }

  // Delegation statt eines Handlers je Karte: die Kacheln kommen teils erst
  // beim Blaettern des Karussells in den DOM.
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-merken]') : null;
    if (!b) return;
    e.preventDefault();
    var liste = lies();
    var handle = b.getAttribute('data-merken');
    var i = liste.indexOf(handle);
    if (i > -1) {
      liste.splice(i, 1);
    } else {
      liste.push(handle);
    }
    schreib(liste);
    zeichne();
  });

  // Die Merkliste-Seite aendert dieselbe Liste, ohne durch den Klick-Handler
  // oben zu laufen. Ohne dieses Signal blieb die Zahl im Kopf nach dem
  // Entfernen auf dem alten Stand stehen, bis die Seite neu geladen wurde.
  document.addEventListener('gs:merken-geaendert', zeichne);

  document.addEventListener('DOMContentLoaded', zeichne);
  zeichne();
})();
